import { render, staticRenderFns } from "./StudentProfileStats.vue?vue&type=template&id=33187bf2&scoped=true&"
import script from "./StudentProfileStats.vue?vue&type=script&lang=js&"
export * from "./StudentProfileStats.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileStats.vue?vue&type=style&index=0&id=33187bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33187bf2",
  null
  
)

export default component.exports